"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
var _hooks = require("../../../hooks");
var _Site = require("../Site.config");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(isMobileView, isGuestUser) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    themeColors = _useContext.themeColors;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var numOfToolbarColumns = isMobileView ? isGuestUser ? 3 : 2 : 5;
  var ccHeaderStyle = (0, _react.useMemo)(function () {
    var ccHeader = (0, _css.css)({
      fontFamily: fontFamily,
      fontSize: pxToRem(16),
      backgroundColor: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light,
      position: 'fixed',
      display: 'flex',
      boxSizing: 'border-box',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      height: pxToRem(_Site.headerHeight),
      padding: "0 ".concat(pxToRem(10)),
      top: 0,
      left: 0,
      zIndex: 5
    });
    var ccHeaderLogo = (0, _css.css)({
      position: 'relative',
      height: '80%',
      display: 'flex',
      alignItems: 'center',
      img: {
        position: 'relative',
        height: '100%'
      }
    });
    var ccHeaderSpacer = (0, _css.css)({
      width: 0,
      height: pxToRem(26),
      display: 'inline-block',
      fontSize: 0,
      borderLeft: "solid ".concat(pxToRem(2), " ").concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.subText),
      opacity: 0.3,
      marginRight: pxToRem(10)
    });
    var ccHeaderLogoLink = {
      height: '100%'
    };
    var ccHeaderToolbar = (0, _css.css)({
      display: 'grid',
      gridAutoFlow: 'column',
      alignItems: 'center',
      columnGap: pxToRem(isMobileView ? 8 : 12),
      '>*': {
        display: 'inline-flex'
      }
    });
    var ccHeaderUserRole = (0, _css.css)({
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main,
      display: 'flex',
      justifyContent: 'space-between',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      backgroundColor: 'transparent',
      border: 'none',
      alignItems: 'center',
      borderRadius: 0,
      lineHeight: '1'
    });
    var ccHeaderUserRoleButton = (0, _css.css)({
      display: 'inline-flex',
      alignItems: 'center',
      columnGap: pxToRem(8),
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main,
      fontWeight: 'bold'
    });
    var ccHeaderUserRoleText = (0, _css.css)({
      display: 'inline-block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: pxToRem(100)
    });
    var ccHeaderLangButtonLabel = (0, _css.css)({
      display: 'flex',
      alignItems: 'center',
      gap: pxToRem(5)
    });
    var ccHeaderLoginButton = (0, _css.css)({
      gridColumn: isMobileView ? "".concat(numOfToolbarColumns, " / ").concat(numOfToolbarColumns) : undefined,
      '> button': {
        fontWeight: 'bold'
      }
    });
    var ccHeaderProfileButton = (0, _css.css)({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      marginInlineStart: pxToRem(15),
      gap: pxToRem(2)
    });
    var ccHeaderProfileButtonName = (0, _css.css)({
      lineHeight: '1'
    });
    var ccHeaderLangButton = (0, _css.css)({
      backgroundColor: 'transparent',
      border: 'none',
      cursor: 'pointer'
    });
    var ccHeaderLangImage = (0, _css.css)(_objectSpread({}, isMobileView && {
      width: pxToRem(30),
      height: pxToRem(30)
    }));
    var ccHeaderProfilePopupTitle = (0, _css.css)({
      fontSize: pxToRem(20),
      fontWeight: 'bold',
      margin: "".concat(pxToRem(5), " ").concat(pxToRem(10))
    });
    var ccHeaderTopMarker = (0, _css.css)({
      display: 'block',
      width: '100%',
      height: 0,
      position: 'absolute',
      bottom: 0
    });
    return {
      ccHeader: ccHeader,
      ccHeaderLogo: ccHeaderLogo,
      ccHeaderLogoLink: ccHeaderLogoLink,
      ccHeaderToolbar: ccHeaderToolbar,
      ccHeaderSpacer: ccHeaderSpacer,
      ccHeaderUserRole: ccHeaderUserRole,
      ccHeaderUserRoleButton: ccHeaderUserRoleButton,
      ccHeaderUserRoleText: ccHeaderUserRoleText,
      ccHeaderLoginButton: ccHeaderLoginButton,
      ccHeaderLangButtonLabel: ccHeaderLangButtonLabel,
      ccHeaderProfileButton: ccHeaderProfileButton,
      ccHeaderProfileButtonName: ccHeaderProfileButtonName,
      ccHeaderLangButton: ccHeaderLangButton,
      ccHeaderLangImage: ccHeaderLangImage,
      ccHeaderProfilePopupTitle: ccHeaderProfilePopupTitle,
      ccHeaderTopMarker: ccHeaderTopMarker
    };
  }, [isMobileView, numOfToolbarColumns, fontFamily, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.subText, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main, pxToRem]);
  return {
    'cc-Header': ccHeaderStyle.ccHeader,
    'cc-Header__logo': ccHeaderStyle.ccHeaderLogo,
    'cc-Header__logo__link': ccHeaderStyle.ccHeaderLogoLink,
    'cc-Header__toolbar': ccHeaderStyle.ccHeaderToolbar,
    'cc-Header__toolbar__spacer': ccHeaderStyle.ccHeaderSpacer,
    'cc-Header__toolbar__user-role': ccHeaderStyle.ccHeaderUserRole,
    'cc-Header__toolbar__user-role__button': ccHeaderStyle.ccHeaderUserRoleButton,
    'cc-Header__toolbar__user-role__text': ccHeaderStyle.ccHeaderUserRoleText,
    'cc-Header__toolbar__login-button': ccHeaderStyle.ccHeaderLoginButton,
    'cc-Header__toolbar__lang-button-label': ccHeaderStyle.ccHeaderLangButtonLabel,
    'cc-Header__toolbar__profile__button': ccHeaderStyle.ccHeaderProfileButton,
    'cc-Header__toolbar__profile__button__name': ccHeaderStyle.ccHeaderProfileButtonName,
    'cc-Header__toolbar__lang-button': ccHeaderStyle.ccHeaderLangButton,
    'cc-Header__toolbar__lang-image': ccHeaderStyle.ccHeaderLangImage,
    'cc-Header__profile-popup__title': ccHeaderStyle.ccHeaderProfilePopupTitle,
    'cc-Header__TopMarker': ccHeaderStyle.ccHeaderTopMarker
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;